import angular from 'angular';
import { MediaDevicePickerController } from './media-device-picker';
import template from './media-device-picker.html';
const component = {
    template,
    bindings: {
        cameras: '<',
        microphones: '<',
        showFullOptions: '<',
        isFlipCameraAvailable: '<',
    },
    controller: MediaDevicePickerController,
};
export default angular
    .module('doxy.common.components.devicePicker', [])
    .component('mediaDevicePicker', component).name;
